function generateDefaultInitialAbTestState() {
  return {
    abTest: null,
  };
}

function abTestReducer(state = generateDefaultInitialAbTestState(), action) {
  let newState;

  switch (action.type) {
    case 'GET_AB_TEST_FULFILLED': {
      newState = {
        ...state,
        abTest: action.payload.response.data.data,
      };
      break;
    }

    case 'SET_AB_TEST_STATE': {
      newState = {
        ...state,
        abTest: action.payload,
      };
      break;
    }

    default:
      newState = state;
  }

  return newState;
}

export default abTestReducer;
export {
  generateDefaultInitialAbTestState,
};
